import { useApiMutation } from '~/hooks';
import { purchaseCreditsApi } from '../repository';
import type {
  PurchaseCreditsData,
  PurchaseCreditsResponse,
} from '../repository/credit';
import { MutationOptions } from '@tanstack/react-query';

/**
 * Mutation hook for purchasing credits with wallet balance
 */
export const usePurchaseCreditsMutation = (
  options?: MutationOptions<
    PurchaseCreditsResponse,
    CustomAxiosError,
    PurchaseCreditsData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: PurchaseCreditsData) => purchaseCreditsApi(data),
    onSuccess: (data, ...rest) => {
      options?.onSuccess?.(data, ...rest);
    },
  });
};
